import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  historyContent: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '270px',
    overflowY: 'auto',
    width: '100%',
    marginTop: '-16px',
  },
  historyItem: {
    marginBottom: '16px',
  },
  historyText: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    color: `${colors.black} !important`,
  },
  cardRoot: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  cardHeaderText: {
    fontSize: fonts.sizes.xsmall,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.4px',
    lineHeight: '16px',
    color: colors.black,
  },
  cellData: {
    textDecoration: 'underline',
    textDecorationColor: colors.primary,
    color: colors.primary,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  defaultMessage: {
    textAlign: 'center',
    marginTop: '16px',
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
  },
});

export default useStyles;
